<template>
  <b-container>
    <b-row>
      <b-col>
        <b-media>
          <h1>Editorial zum Medienarchiv68</h1>

          <figure class="m68_article_teaser">
            <b-img thumbnail fluid src="@/assets/10063903_42b0a83e04.jpg" alt="Dr. Mathias Döpfner" />
            <figcaption>von Dr. Mathias Döpfner, Vorstandsvorsitzender Axel Springer SE</figcaption>
          </figure>

          <p class="lead">Zu wissen, wie es wirklich war, ist schon immer ein Grundimpuls des Journalismus und der
            Geschichtswissenschaft gewesen – und das ist auch unser Anliegen mit dem Medienarchiv68.</p>
          <p>Wie wichtig es ist, dass wir uns mit diesem Kapitel deutscher Geschichte und unseres Unternehmens erneut
            auseinandersetzen, zeigen zwei Meldungen des vergangenen Jahres: Karl-Heinz Kurras, der den Studenten Benno
            Ohnesorg am 2. Juni 1967 erschoss, war ein inoffizieller Mitarbeiter der Staatssicherheit. Und der
            Dutschke-Attentäter Josef Bachmann hielt enge Kontakte zu Neonazis, die von der Stasi wie auch der Polizei
            beobachtet wurden. Beide Erkenntnisse werfen die Frage auf: Was wäre gewesen, wenn das alles schon damals
            bekannt geworden wäre?</p>
          <p>Wir wollen aber nicht spekulieren, sondern uns an das halten, was geschrieben steht. Im Medienarchiv68
            haben
            wir rund 5.900 Beiträge, Kommentare, Leserbriefe, Karikaturen, Reportagen, Glossen und Interviews aus den
            Jahren 1966 bis 1968 zusammengestellt, die ein Bild vermitteln, wie die Redaktionen von Axel Springer, aber
            auch andere Medien wie der Berliner „Tagesspiegel“ über die 68er-Bewegung berichtet haben. Was die Texte aus
            den Blättern der Axel Springer SE betrifft, so ist die Dokumentation nach unserem besten Wissen vollständig.
            Sollten uns dennoch einzelne Artikel entgangen sein, sind wir für Hinweise dankbar. </p>
          <p>Schon länger habe ich mir gewünscht, dass unabhängige Wissenschaftler die publizistische Positionierung der
            Axel-Springer-Zeitungen in der damaligen Zeit wissenschaftlich aufarbeiten. Mit dem Material des
            Medienarchivs68 ist dies erstmals über eine für jedermann zugängliche Datenbank online und umfassend
            möglich.
            Da mag es dann bei der Recherche Überraschungen geben, für uns oder für andere. Mein persönliches,
            vorläufiges
            Fazit: Wenn man genauer hinschaut, ergibt sich ein differenziertes Bild. Die These, das Haus Axel Springer
            sei
            eine zentral gelenkte Meinungsmaschine gewesen, welche die Studentenbewegung verhindern wollte, bestätigt
            sich
            jedenfalls nicht. </p>
          <p>Kommentarzeilen wie „Stoppt den Terror der Jung-Roten jetzt“ (BILD Berlin, 7. Februar 1968) oder „Wer
            Terror
            produziert, muss Härte in Kauf nehmen." (B.Z., 3. Juni 1967) werden immer wieder zitiert. Aber war ebenso
            bekannt, dass die B.Z. auch schrieb „Es ist ein Unding, einen Dutschke zum ,Volksfeind Nr. 1’ stempeln zu
            wollen“ (B.Z., 22. Februar 1968)? Dass die WELT den Freispruch der Kommunarden Teufel und Langhans begrüßte
            (WELT, 23. März 1968)? Oder dass BILD nach dem Attentat auf Rudi Dutschke titelte „Millionen bangen mit“
            (BILD
            Berlin, 13. April 1968)? Manche Klischees in den Köpfen erweisen sich auch als Endmoränen einer bis heute
            wirkungsvollen SED-Propaganda und Stasi-Desinformation.</p>
          <p>Unser Haus hat großes Interesse an einer ergebnisoffenen Debatte. Dass die Diskussion im vergangenen Jahr
            über die Rolle unseres Verlags um das Jahr 1968 so intensiv und dynamisch war, hat mich gefreut und
            beeindruckt. Forschungsarbeiten und Dokumentationen wie „Feindbild Springer“ des Forschungsverbunds
            SED-Staat
            oder Tilman Jens’ WDR-Dokumentation „Bespitzelt Springer“ haben dazu viel beigetragen. Auch durch die
            Ausrichtung der Tagung „1968 und die deutschen Unternehmen“ der Gesellschaft für Unternehmensgeschichte oder
            die Öffnung unseres Archivs für die Axel Springer-Biographie von Hans-Peter Schwarz haben wir – so glaube
            ich
            – die Aufarbeitung befördert. Natürlich hätte ich mir gewünscht, dass unser Interesse an einem ernsthaften
            Dialog – dazu gehört ausdrücklich auch die neuerliche Entschuldigung für die journalistischen Fehler, die
            unser Haus damals gemacht hat – erwidert worden wäre. Dass maßgebliche Akteure der 1968er Bewegung, die
            immer
            den offenen Diskurs gefordert haben, diesen auf unsere Einladung zum „Springer Tribunal 2009“ hin verweigert
            haben, war eine Enttäuschung und eine verpasste Chance.</p>
          <p>Meine Hoffnung ist, dass dieses Medienarchiv als eine Einladung verstanden wird. Eine Einladung nicht nur
            an
            Zeitzeugen von damals, sondern ausdrücklich auch an die Generation danach, sich selbst einen Eindruck zu
            verschaffen und herauszufinden, wie es damals wirklich war. Sollte sich daraus ein neuer Impuls für die
            weitere Debatte und wissenschaftliche Aufarbeitung ergeben, würden wir uns freuen. </p>
          <p>Ich wünsche Ihnen spannendes Stöbern und erkenntnisreiche Recherchen. </p>
          <p>
            <b-link :to="{ name: 'archive' }">Zur Recherche in der Datenbank</b-link>
          </p>
        </b-media>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  import store from '@/store'

  export default {
    name: 'HomePage',
    created () {
      store.commit('setBreadcrumb', ['Startseite'])
    }
  };
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/HomePage.vue